import { render, staticRenderFns } from "./Therapies.vue?vue&type=template&id=a8c641ac&scoped=true"
import script from "./Therapies.vue?vue&type=script&lang=js"
export * from "./Therapies.vue?vue&type=script&lang=js"
import style0 from "./Therapies.vue?vue&type=style&index=0&id=a8c641ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c641ac",
  null
  
)

export default component.exports